import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hakkimizda() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Update page title and meta
    document.title = "Hakkımızda - 3D Print Pro | Ankara'nın Güvenilir 3D Yazıcı Servisi";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '2015\'ten beri Ankara\'da 3D yazıcı teknolojisinde öncü firmayız. Uzman ekibimiz ve modern donanımımızla profesyonel hizmet sunuyoruz.');
    }

    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Hakkımızda - 3D Print Pro",
      "description": "2015'ten beri Ankara'da 3D yazıcı teknolojisinde öncü firmayız",
      "mainEntity": {
        "@type": "Organization",
        "name": "3D Print Pro",
        "foundingDate": "2015",
        "description": "Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman firma",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3",
          "addressLocality": "Yenimahalle",
          "addressRegion": "Ankara",
          "postalCode": "06480",
          "addressCountry": "TR"
        },
        "telephone": "+903123945635",
        "email": "info@3dprinterservis.com"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Fallback image in case the generated URL fails
  const fallbackImage =
    'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png';

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            className={`text-center transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              <span className="text-red-600">Hakkımızda</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Ankara'da 3D yazıcı teknolojisi alanında öncü firmayız. 2015 yılından beri profesyonel hizmet veriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div
              className={`transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
              }`}
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Hikayemiz</h2>
              <p className="text-lg text-gray-600 mb-6">
                3D Print Pro, 2015 yılında Ankara'da 3D yazıcı teknolojisine olan tutkumuzla kuruldu. O günden bu yana,
                3D yazıcı sahiplerinin cihazlarından maksimum verim alabilmeleri için profesyonel hizmetler sunuyoruz.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Uzman ekibimiz, sürekli gelişen 3D yazıcı teknolojilerini yakından takip ederek, müşterilerimize en
                güncel ve etkili çözümler sunmaktadır. Kaliteli hizmet anlayışımız ve müşteri memnuniyeti odaklı
                yaklaşımımızla sektörde güvenilir bir marka haline geldik.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">500+</div>
                  <div className="text-gray-600">Tamir Edilen Cihaz</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">8+</div>
                  <div className="text-gray-600">Yıllık Deneyim</div>
                </div>
              </div>
            </div>
            <div
              className={`transition-all duration-1000 delay-300 ${
                isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
              }`}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/880f460e7cc9d6fb52ddad927c7fb5b2.jpg"
                alt="3D Print Pro Atölyesi"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div
              className={`transition-all duration-1000 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-target-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h3>
                <p className="text-gray-600">
                  3D yazıcı teknolojisinin Ankara'da yaygınlaşmasına katkıda bulunmak, kullanıcıların cihazlarından
                  maksimum verim alabilmeleri için profesyonel destek sağlamak ve sektörde kalite standartlarını
                  yükseltmektir.
                </p>
              </div>
            </div>
            <div
              className={`transition-all duration-1000 delay-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-eye-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h3>
                <p className="text-gray-600">
                  Türkiye'nin en güvenilir 3D yazıcı servis merkezi olmak, teknolojik yenilikleri takip ederek müşterilerimize
                  en iyi hizmeti sunmak ve 3D yazıcı ekosisteminin gelişimine öncülük etmektir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Değerlerimiz</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Çalışma prensiplerimiz ve değerlerimiz</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-shield-check-line',
                title: 'Güvenilirlik',
                description:
                  "Müşterilerimizin güvenini kazanmak ve korumak en önemli önceliğimizdir.",
              },
              {
                icon: 'ri-star-line',
                title: 'Kalite',
                description: 'Her işimizde en yüksek kalite standartlarını uygularız.',
              },
              {
                icon: 'ri-lightbulb-line',
                title: 'İnovasyon',
                description: 'Teknolojik gelişmeleri takip eder, yenilikçi çözümler sunarız.',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Müşteri Odaklılık',
                description: 'Müşteri memnuniyeti bizim için her şeyden önemlidir.',
              },
            ].map((value, index) => (
              <div
                key={index}
                className={`text-center p-6 transition-all duration-1000 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${600 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Teknoloji ve İnovasyon</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Modern teknoloji ve yenilikçi yaklaşımımız</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-cpu-line',
                title: 'İleri Teknoloji',
                description: 'En son teknoloji donanımlar ve yazılımlarla çalışıyoruz',
                color: 'bg-blue-100 text-blue-600'
              },
              {
                icon: 'ri-microscope-line',
                title: 'Hassas Analiz',
                description: 'Detaylı teşhis ve analiz süreçleri ile sorunları belirliyoruz',
                color: 'bg-green-100 text-green-600'
              },
              {
                icon: 'ri-tools-line',
                title: 'Profesyonel Araçlar',
                description: 'Endüstri standardında kalibrasyon ve tamir araçları',
                color: 'bg-purple-100 text-purple-600'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Kalite Güvencesi',
                description: 'Her işlemde kalite kontrol ve test süreçleri',
                color: 'bg-red-100 text-red-600'
              },
              {
                icon: 'ri-time-line',
                title: 'Hızlı Çözüm',
                description: 'Etkili süreç yönetimi ile hızlı servis sağlıyoruz',
                color: 'bg-yellow-100 text-yellow-600'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Destek',
                description: 'Acil durumlar için kesintisiz teknik destek hizmeti',
                color: 'bg-indigo-100 text-indigo-600'
              }
            ].map((feature, index) => (
              <div
                key={index}
                className={`bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${700 + index * 100}ms` }}
              >
                <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center mb-6`}>
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certificates & Awards */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Sertifikalar ve Başarılar</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kalite ve uzmanlığımızın kanıtları
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-award-line',
                title: 'ISO 9001 Kalite Belgesi',
                description: 'Kalite yönetim sistemi sertifikası',
              },
              {
                icon: 'ri-medal-line',
                title: 'Teknik Yeterlilik',
                description: '3D yazıcı teknolojileri uzmanlık belgesi',
              },
              {
                icon: 'ri-shield-star-line',
                title: 'Müşteri Memnuniyeti',
                description: '%98 müşteri memnuniyet oranı',
              },
              {
                icon: 'ri-trophy-line',
                title: 'Sektör Ödülü',
                description: 'En İyi Servis Merkezi ödülü 2023',
              },
            ].map((achievement, index) => (
              <div
                key={index}
                className={`text-center p-6 bg-gray-50 rounded-xl transition-all duration-1000 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${800 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${achievement.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{achievement.title}</h3>
                <p className="text-gray-600 text-sm">{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Bizimle Çalışmaya Hazır mısınız?</h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            3D yazıcı ihtiyaçlarınız için uzman ekibimizle iletişime geçin. Size en iyi hizmeti sunmak için buradayız.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/iletisim"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              İletişime Geç
            </Link>
            <Link
              to="/hizmetler"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer"
            >
              Hizmetlerimizi İncele
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <Link to="/hizmetler/tamir" className="hover:text-white transition-colors">
                    3D Yazıcı Tamiri
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetler/bakim" className="hover:text-white transition-colors">
                    Bakım Servisi
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">
                    Kurulum
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetler" className="hover:text-white transition-colors">
                    Tüm Hizmetler
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <Link to="/hakkimizda" className="hover:text-white transition-colors">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="hover:text-white transition-colors">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>
                  1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara
                </p>
                <p>0312 394 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>
              &copy; 2024 3D Print Pro. Tüm hakları saklıdır. |
              <a
                href="https://cdco.com.tr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors ml-1"
              >
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
